import { BlobStorageHelper } from 'app/utils/constants';
import axios, { AxiosRequestConfig, AxiosResponse } from 'axios';
import { apiClient } from './clients/api-client';
import { BlobAttachmentDto } from 'generated/request-backend';

export class ApiRequestService {
    config?: AxiosRequestConfig = {};

    private cancellationToken = axios.CancelToken.source();

    static createInstance(): ApiRequestService {
        const activeInstance = new ApiRequestService();
        activeInstance.cancellationToken = axios.CancelToken.source();
        if (activeInstance.config) {
            activeInstance.config.cancelToken = activeInstance.cancellationToken.token;
        }
        return activeInstance;
    }

    cancelRequests() {
        this.cancellationToken.cancel('RequestCancellation');
        return ApiRequestService.createInstance();
    }

    generateFileSasToken = (entity: string, containerName: string, fileName: string) => apiClient.get(`/${entity}/file/GenerateFileSasToken/${containerName}/${fileName}`);

    /**
     * Upload a file to blob storage via service API
     * @param file
     * @param blobName
     * @returns Promise object with blob information includeing URLs
     */
    uploadFileToBlobStorageAsync = async (file: File, blobName: string) : Promise<AxiosResponse<BlobAttachmentDto>> => {
        const formData = new FormData();
        formData.append("file", file, blobName);
        return await apiClient.post(BlobStorageHelper.UPLOAD_ATTACHMENT_ROUTE, formData);
    }

    // Download Attachment Blob
    /**
     * Get the BlobSasUri to download the specified blob (file)
     * @param blobName
     * @returns BlobSasUri
     */
    getFileSasUriFromBlobStorageAsync = async (blobName: string) : Promise<AxiosResponse<BlobAttachmentDto>> => {
        return await apiClient.get(`${BlobStorageHelper.DOWNLOAD_ATTACHMENT_ROUTE}/${blobName}`);
    }
}